// extracted by mini-css-extract-plugin
export var copyableField = "_s6-4";
export var customerBadge = "_s6-0";
export var customerInfoTitle = "_s6-2";
export var details = "_s6-1";
export var dropdownContainer = "_s6-5";
export var dropdownImage = "_s6-6";
export var editAssigneeForm = "_s6-a";
export var editButton = "_s6-3";
export var email = "_s6-7";
export var hidden = "_s6-d";
export var input = "_s6-8";
export var saveButton = "_s6-b";
export var shopifyIcon = "_s6-c";
export var suggestionBadge = "_s6-e";
export var suggestionText = "_s6-f";
export var username = "_s6-9";